import { Perimeter } from 'vue-kindergarten';

export default class BasePerimeter extends Perimeter {
  isLoggedIn() {
    return !this.isNotLoggedIn();
  }

  isNotLoggedIn() {
    return !this.child;
  }

  isAdmin() {
    return this.isLoggedIn() && this.child.roles.includes('admin');
  }

  hasPermission(action) {
    if (this.isAdmin()) return true;

    return this.isLoggedIn() && this.child.permissions.includes(action);
  }
}
